/* eslint-disable max-classes-per-file */
import _ from "lodash";
import { DateUtils } from "~app/common/utils/date-utils";
import { IDocumentKeyFilterSource, IKeyValue, IKeyValueGroup, ITplArbetsorder } from "./dtos";

export class TplArbetsorderDetailsQuery {
    arbetsorderId: number;

    constructor(arbetsorderId: number) {
        this.arbetsorderId = arbetsorderId;
    }
}

export class VirkesorderBegransningsforslagQuery {
    arbetsorderId: number;

    constructor(arbetsorderId: number) {
        this.arbetsorderId = arbetsorderId;
    }
}

export class TplDestineringsraderQuery {
    arbetsorderId: number;

    constructor(arbetsorderId: number) {
        this.arbetsorderId = arbetsorderId;
    }
}

export class TplGetHandelserQuery {
    arbetsorderIds: number[];

    constructor(arbetsorderIds: number[]) {
        this.arbetsorderIds = arbetsorderIds;
    }
}

export class TplSearchArbetsorderQuery {
    produktionsomradeIdList: number[];
    transportsatt: string;
    periodFrom: Date;
    periodTom: Date;
    periodType: number;
    arbetsorderIdList: number[];

    constructor(props?: any) {
        if (props !== undefined) {
            _.merge(this, props);
        } else {
            this.produktionsomradeIdList = [];
            this.transportsatt = "Rundvirke";
            this.periodFrom = DateUtils.now();
            this.periodTom = DateUtils.nowAddMonths(1);
            this.periodType = 0;
        }
    }
}

export class TplTransportforetagHandelssortimentQuery {
    arbetsorderIds: number[];

    constructor(arbetsorderIds: number[]) {
        this.arbetsorderIds = arbetsorderIds;
    }
}

export interface ITplSearchArbetsorderQueryResult {
    arbetsorderList: ITplArbetsorder[];
    maskinlagList: IKeyValue[];
    mottagningsplatsList: IKeyValue[];
    handelssortimentList: IKeyValueGroup[];
    transportforetagList: IKeyValue[];
    updatedTransportforetag: boolean;
}

export interface ITransportforetag {
    id: number;
    namn: string;
    color: string;
    aktiv: boolean;
    koordinater: any[];
    guid: string;
    huvudkod: string;
    transportkapacitet?: number;
    transportunderlagTillExtern: boolean;
}

export interface IBefraktare {
    id: number;
    namn: string;
    huvudkod: string;
    aktiv: boolean;
    befraktare: boolean;
    color: string;
}

export interface ITplTransportforetagHandelssortimentDto {
    arbetsorderId: number;
    handelssortimentId: number;
    handelssortimentNamn: string;
    transportforetagId: number;
    egenTransport: boolean;
    isDestinerad: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ITransportforetagForTilldelningQueryResult extends ITransportforetag { }

export interface ITplArbetsorderDestinerbaraMottagningsplatserQuery {
    arbetsorderIds: number[];
    handelssortimentId: number;
}

export interface ITplArbetsorderDestinerbaraMottagningsplatserQueryResponse {
    key: IKeyValue;
    documentIdList: number[];
    inaktivaOnDokument: number[];
}

export class TplProduktionsomradefilterQueryArbetsorder {
    id: number;
}

export class TplProduktionsomradefilterQuery {
    arbetsordrar: TplProduktionsomradefilterQueryArbetsorder[] = [];

    constructor(aos: ITplArbetsorder[]) {
        aos.forEach((a: ITplArbetsorder) => {
            this.arbetsordrar.push({
                id: a.id
            });
        });
    }
}

export interface ITplProduktionsomradefilterQueryResult {
    marknadsomraden: IMarknadsomrade[];
}

export interface IMarknadsomrade {
    id: number;
    guid: string;
    namn: string;
    children: IResultatomrade[];
}
export interface IResultatomrade {
    id: number;
    guid: string;
    marknadsomradeId: number;
    namn: string;
    children: IProduktionsomrade[];
}
export interface IProduktionsomrade {

    id: number;
    guid: string;
    resultatomradeId: number;
    namn: string;
}

export class TplDestineringsomradefilterQuery {
    arbetsordrar: TplDestineringsomradefilterQueryArbetsorder[] = [];

    // eslint-disable-next-line sonarjs/no-identical-functions
    constructor(aos: ITplArbetsorder[]) {

        aos.forEach((a: ITplArbetsorder) => {
            this.arbetsordrar.push({
                id: a.id
            });
        });
    }
}

export class TplDestineringsomradenMapQuery {
    handelssortiment?: number[];
    mottagningsplatser?: number[];
}

export class TplDestineringsomradenMapQueryResult {
    destineringsomraden: number[];
}

export class TplDestineringsomradefilterQueryArbetsorder {
    id: number;
}

export interface ITplDestineringsomradefilterQueryResult {
    documents: IDocumentKeyFilterSource[];
    keys: IKeyValueGroup[];
}

export class TplDestineringRuttQuery {
    arbetsorderId: number;
    handelssortimentId: number;
    mottagningsplatsId: number;

    constructor(arbetsorderId: number, handelssortimentId: number, mottagningsplatsId: number) {
        this.arbetsorderId = arbetsorderId;
        this.handelssortimentId = handelssortimentId;
        this.mottagningsplatsId = mottagningsplatsId;
    }
}

export interface ITplDestineringRuttQueryResult {
    mottagningsplats: string;
    handelssortiment: string;
    tillaggsavstandStorstaAvlagg?: number;
    startpunktJusterad: boolean;
    defaultStartPunkt: IGeolocationDto;
    startPunkt: IGeolocationDto;
    slutPunkt: IGeolocationDto;
    arbetsorderTransportavtand: IArbetsorderTransportavtand[];
}

export class TplKvvNyRuttQuery {
    startPunkt: IGeolocationDto;
    krontVagvalMotstand?: number;
    arbetsorderId: number;
    mottagningsplatsId: number;
    barighetsklassData: TplKvvNyRuttBkDataQuery[];

    constructor(
        startPunkt: IGeolocationDto,
        arbetsorderId: number,
        mottagningsplatsId: number,
        barighetsklassData: TplKvvNyRuttBkDataQuery[],
        krontVagvalMotstand?: number) {
        this.startPunkt = startPunkt;
        this.arbetsorderId = arbetsorderId;
        this.krontVagvalMotstand = krontVagvalMotstand;
        this.mottagningsplatsId = mottagningsplatsId;
        this.barighetsklassData = barighetsklassData;
    }
}

export class TplKvvNyRuttBkDataQuery {
    viaPunkter: IGeolocationDto[];
    barighetsklass: string;
    krontVagvalMotstand?: number;
    constructor(
        viaPunkter: IGeolocationDto[],
        barighetsklass: string,
        krontVagvalMotstand?: number) {
        this.viaPunkter = viaPunkter;
        this.barighetsklass = barighetsklass;
        this.krontVagvalMotstand = krontVagvalMotstand;
    }
}

export interface ITplKvvNyRuttQueryResult {
    krontvagvalResponseData: IKvvData[];
}

export interface IKvvData {
    routeGeometry: string;
    krontVagvalKm: number;
    felmeddelandekod: string;
    felmeddelande: string;
    barighetsklass: string;
    berakningstid: Date;
}

export interface IArbetsorderTransportavtand {
    id: number;
    routeGeometry: string;
    krontVagvalKm: number;
    extraKm: number;
    vagmotstand: number;
    barighetsklass: string;
    viaPunkter: IGeolocationDto[];
    active: boolean;
    felmeddelande: string;
    felmeddelandekod: string;
    berakningstid?: Date;
}

export interface IGeolocationDto {
    easting?: number;
    northing?: number;
    index?: number;
    barighetsklasser?: string[];
}
